import type { tutorialsApi } from 'app/src/services/welfareportal'

export const mockTutorials: tutorialsApi.Tutorials[] = [
  {
    title:
      'PWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsumPWS Mondo Welfare dinventa leader lorem ipsum',
    id: '1',
    date: '2024-10-10',
    link: '/movies/TutorialGiftCard.mp4',
    image: '/images/tutorial-gift-card.png',
  },
  {
    title: 'PWS Mondo Welfare dinventa leader lorem ipsum',
    id: '2',
    date: '2024-10-10',
    link: '/movies/TutorialGiftCard.mp4',
    image: '/images/tutorial-rimborso-spese.png',
  },
  {
    title: 'PWS Mondo Welfare dinventa leader lorem ipsum',
    id: '3',
    date: '2024-10-10',
    link: '/movies/TutorialGiftCard.mp4',
    image: '/images/tutorial-esami-sangue.png',
  },
]
